import { api } from "@/libs/api-client";
import { createServerFn } from "@tanstack/react-start";
import { zodValidator } from "@tanstack/zod-adapter";
import {
  type OtpRequestInput,
  OtpScene,
  type OtpValidateInput,
  otpRequestSchema,
  otpValidateSchema,
} from "./otp.schema";

type OtpApiMap = Record<
  OtpScene,
  {
    request: (input: OtpRequestInput) => Promise<boolean>;
    validate: (input: OtpValidateInput) => Promise<boolean>;
  }
>;

const otpApi: OtpApiMap = {
  [OtpScene.VerifyMail]: {
    async request({ context }) {
      return await api
        .post("open-api/auth/register/verifyMail", {
          json: context,
        })
        .json();
    },

    async validate() {
      return await Promise.resolve(true);
    },
  },
  [OtpScene.ResetPasswordVerifyMail]: {
    async request({ context }) {
      return await api
        .post("open-api/auth/reset/verifyMail", {
          json: context,
        })
        .json();
    },

    async validate() {
      return await Promise.resolve(true);
    },
  },
};

export const requestOtp = createServerFn({ method: "POST" })
  .validator(zodValidator(otpRequestSchema))
  .handler(async ({ data }) => {
    const { request } = otpApi[data.scene];
    return await request(data);
  });

export const validateOtp = createServerFn({ method: "POST" })
  .validator(zodValidator(otpValidateSchema))
  .handler(async ({ data }) => {
    const { validate } = otpApi[data.params.scene];
    return await validate(data);
  });
